<template>
  <div class="wrapper">
    <div class="tilte-text"> {{ recharge ? '账户充值' : '提现' }}</div>
    <div v-if="recharge">
      <div class="form-group">
        <div class="label-wrap">可用余额</div>
        <div class="form-item-wrap">
          <span class="money">{{ balance }}</span>
          <span>元</span>
          <div class="refresh">
            <Icon type="md-refresh" size="24" color="#999"/>
            <span class="refresh-text" @click="refreshAccount"> 刷新</span>
          </div>
          <!-- <div class="btn-wrapper" @click="withdraw"> -->
          <div class="btn-wrapper" @click="$router.push('/pc/user/accountWithdrawal')">
            <span class="btn">提现</span>
          </div>
          <div class="btn-sms-tip" @click="balanceTip">
            <span>余额不足提醒</span>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="label-wrap">支付方式</div>
        
        <div class="form-item-wrap">
          <div class="alipay-icon-wrap" v-if="isPayType == 2">
            <img src="https://web.taototo.cn/seller/image/withdrawal_btn_wechat.png" alt="">
            <div class="pay-item-text">微信支付</div>
          </div>
          <div class="alipay-icon-wrap" v-else>
            <img src="@/assets/img/icon_alipay.png"/>
            <div class="alipay-text">支付宝</div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="label-wrap">
          锁定金额
          <Poptip trigger="hover" placement="bottom">
            <div slot="content">
              提交订单时，按市场价先预扣定金。订单成交后释放定金并扣除订单实际应付金额
            </div>
            <div class="label-icon">
              <Icon type="ios-help-circle-outline"/>
            </div>
          </Poptip>
        </div>
        <div class="form-item-wrap">
          <span class="money">{{ freeze_amount }}</span>
          <span>元</span>
        </div>
      </div>
      <!--      <div class="form-group">-->
      <!--        <div class="label-wrap">收款账户</div>-->
      <!--        <div class="form-item-wrap font-normal">-->
      <!--          {{alipayAccount}}（{{alipayRealName}}）-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="form-group money-form">
        <div class="label-wrap">充值金额</div>
        <div class="form-item-wrap">
          <ul class="money-list">
            <li v-for="(item,index) of rechargeAmountList" :key="index"
                :class="( moneyActiveIndex == index && !focusActive)?'money-list-item active':'money-list-item'"
                @click="chooseMoney(item,index)">{{ item }}元
            </li>
            <li class="other-money">
              <div class="money-tip">其他金额</div>
              <div class="money-wrapper" :class="focusActive?'money-wrapper_active':''">
                <input v-model="selectMoney" type="text" ref="customMoney" @focus="handleFocus" />
              </div>
            </li>
            <li class="money-list-item confirm-btn" @click="subCustomMoney()">确定</li>
          </ul>
        </div>
      </div>

      <div class="form-group alipay-code">
        <div class="label-wrap">扫码支付</div>
        <div class="form-item-wrap">
          <div class="alipay-code-wrap">
            <div class="alipay_box_img">
              <!--              <div class="pay-qrcode-img">-->
              <!--                <img class="bg-img" src="@/assets/img/promotion/pay_bg.png">-->
              <!--                <div class="qrcode-img">-->
              <!--                  <img :src="qrcode_url">-->
              <!--                </div>-->
              <!--              </div>-->
              <div class="pay">
                <div class="pay-item" :class="isPayType == 1?'pay-item-active':''" @click="selectPay(1)">
                  <img src="https://web.taototo.cn/seller/image/withdrawal_btn_alipay.png" alt="">
                  <div class="pay-item-text">支付宝</div>
                </div>
                <div class="pay-item" :class="isPayType == 2?'pay-item-active':''" @click="selectPay(2)">
                  <img src="https://web.taototo.cn/seller/image/withdrawal_btn_wechat.png" alt="">
                  <div class="pay-item-text">微信支付</div>
                </div>
                <div class="pay-item" :class="isPayType == 3?'pay-item-active':''" @click="selectPay(3)" v-if="false">
                  <img src="https://web.taototo.cn/seller/image/withdrawal_btn_alipay.png" alt="">
                  <div class="pay-item-text">银联支付</div>
                </div>
              </div>
              <div class="pay-qrcode">
                <div class="qrcode-top">
                  <img :src="isPayImg" alt="">
                  <div class="qrcode-top-text">{{ isPayTitle }}</div>
                </div>
                <div class="qrcode-center" :style="'background:' + isPayBgColor">
                  <div class="qrcode-center-img" v-loading="loading">
                    <!--                    openSxyPay等于3时使用首信易支付二维码-->
                    <img v-if="payType == 3" :src="openSxyPay == 3?qrcodeImg:qrcode_url" alt="">
                    <div v-else id="qrcode" ref="qrcode"></div>
                  </div>
                  <div class="qrcode-center-text">{{ isPayText }}</div>
                </div>
              </div>
            </div>
            <div class="alipay_box_img">
            </div>
            <!--            <div class="alipay-code-desc">-->
            <!--              <div class="recharge-tip">-->
            <!--                已充值？未到账-->
            <!--              </div>-->
            <!--              <div class="order-input">-->
            <!--                <div>输入交易订单</div>-->
            <!--                <Poptip trigger="hover"-->
            <!--                        placement="bottom"-->
            <!--                        width="400">-->
            <!--                  <div slot="content">-->
            <!--                    <img style="width:365px"-->
            <!--                         src="@/assets/img/promotion/account/example.png" />-->
            <!--                  </div>-->
            <!--                  <div class="icon-div">-->
            <!--                    <Icon type="ios-help-circle-outline"-->
            <!--                          size="24"-->
            <!--                          color="#B6B6B6" />-->
            <!--                  </div>-->
            <!--                </Poptip>-->
            <!--                <div class="order-input-content">-->
            <!--                  <input type="text"-->
            <!--                         placeholder="支付宝转账记录上的交易订单号"-->
            <!--                         v-model="alipayTrade" />-->
            <!--                </div>-->
            <!--                <div class="order-btn">-->
            <!--              <span class="btn"-->
            <!--                    @click="showTip">确定</span>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--              <div class="order-tip-div">-->
            <!--                <p>1.扫码支付完成后，点击余额右边的“刷新”按钮，可获取充值金额；</p>-->
            <!--                <p>2.若刷新后，余额并未增加，请您手动认领；</p>-->
            <!--                <p>3.若认领失败，请联系客服为您手动确认。</p>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
      <account-tip ref="AccountTip"></account-tip>
      <withdraw ref="withraw" :info="withdrawInfo"></withdraw>
      <BalanceTip ref="BalanceTip" :info="balanceTipInfo"></BalanceTip>
    </div>
    <!--    新提现页面-->
    <withdraw-index :balance="balance" ref="withdrawIndex" v-if="!recharge" :official="false"
                    :max_withdraw_amount="this.withdrawInfo.max_withdraw_amount"></withdraw-index>
    <!--    <div v-else>-->
    <!--      <div class="form-group">-->
    <!--        <div class="label-wrap">账户余额</div>-->
    <!--        <div class="form-item-wrap">-->
    <!--          <span class="money">{{balance}}</span>-->
    <!--          <span>元</span>-->
    <!--          <div class="refresh">-->
    <!--            <Icon type="md-refresh"-->
    <!--                  size="24"-->
    <!--                  color="#999" />-->
    <!--            <span class="refresh-text" @click="refreshAccount"> 刷新</span>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="form-group">-->
    <!--        <div class="label-wrap">提现金额</div>-->
    <!--        <el-input v-model="price" placeholder="请输入提现金额" class="input-price"></el-input>-->
    <!--        <div class="price-text">可提现金额为{{balance}}，</div><span class="price-all" @click="selectAll">全部提现</span>-->
    <!--      </div>-->
    <!--      <div class="form-group">-->
    <!--        <div class="label-wrap">提现到</div>-->
    <!--        <div class="price-div" v-for="(item,index) in typeList" :key="index" :class="type == index?'price-div-active':''" @click="select(index)">-->
    <!--          {{ item.text }}-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="price-number" v-if="type == 0">-->
    <!--        <div class="price-text">手续费：</div><span class="price-span">￥1</span>-->
    <!--        <div class="price-text">实际到账：</div><span class="price-span2">￥999</span>-->
    <!--      </div>-->
    <!--      <div class="price-list" v-if="type == 0">-->
    <!--        <div  :class="activeCard?'list-item-active':'list-item'" @click="selectCard()">-->

    <!--        </div>-->
    <!--        <div class="list-add" @click="addCard()" :class="active?'list-add-active':''">-->
    <!--          <img class="list-add-icon" :src="addImage" alt="">-->
    <!--          <div class="list-add-text" :class="active?'list-add-text-active':''">添加银行卡</div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="form-group">-->
    <!--        <div class="label-wrap">收款人</div>-->
    <!--        <el-input v-model="name" placeholder="请输入支付宝真实姓名" class="input-price"></el-input>-->
    <!--      </div>-->
    <!--      <div class="form-group">-->
    <!--        <div class="label-wrap">收款账户</div>-->
    <!--        <el-input v-model="number" placeholder="请输入收款账户" class="input-price"></el-input>-->
    <!--      </div>-->
    <!--      <div class="price-hint">-->
    <!--        <div class="hint-title">注意事项：</div>-->
    <!--        <div class="hint-text">1、使用银行卡提现的，提现金额1000元以下的需要收取1元/笔代付费，1000元及以上的不收代付费，代付费用由代付公司收取。</div>-->
    <!--        <div class="hint-text">2、计划于X年X月X日，关闭微信与支付宝提现，请各位安排好相关事项。</div>-->
    <!--      </div>-->
    <!--      <div class="price-button">-->
    <!--        确定-->
    <!--      </div>-->
    <!--    </div>-->
    <!--&lt;!&ndash;    添加银行卡&ndash;&gt;-->
    <!--    <el-dialog-->
    <!--      :title="hintShow?'提示':'添加银行卡'"-->
    <!--      :visible.sync="addVisible"-->
    <!--      width="460px"-->
    <!--      :before-close="close">-->
    <!--     <div class="card-message" v-if="!hintShow">-->
    <!--       <div class="message-item">-->
    <!--         <div class="item-text">姓名</div>-->
    <!--         <div class="item-input">-->
    <!--           <input placeholder="请输入姓名" v-model="cardName" @input="getName"></input>-->
    <!--         </div>-->
    <!--       </div>-->
    <!--       <div class="message-item">-->
    <!--         <div class="item-text">银行卡号</div>-->
    <!--         <div class="item-input" >-->
    <!--           <input placeholder="请输入银行卡号" v-model="cardNumber"></input>-->
    <!--         </div>-->
    <!--       </div>-->
    <!--       <div class="message-hint">输入卡号自动识别开户行</div>-->
    <!--       <div class="message-item">-->
    <!--         <div class="item-text">开户行</div>-->
    <!--         <el-select class="item-select" v-model="cardType" placeholder="请选择">-->
    <!--           <el-option-->
    <!--             v-for="item in cardOptions"-->
    <!--             :key="item.value"-->
    <!--             :label="item.label"-->
    <!--             :value="item.value">-->
    <!--           </el-option>-->
    <!--         </el-select>-->
    <!--       </div>-->
    <!--       <div class="card-button">-->
    <!--         <div class="card-button-confirm"  @click="addVisible = false">确 定</div>-->
    <!--         <div class="card-button-cancel" @click="addVisible = false">取 消</div>-->
    <!--       </div>-->
    <!--     </div>-->
    <!--      <div class="card-hint">-->
    <!--        <div class="card-hint-text">公司业务调整，计划于X年X月X日，关闭微信与支付宝提现，请各位安排好相关事项，及时绑定银行卡，避免无法提现。</div>-->
    <!--        <div class="card-hint-confirm" @click="addVisible = false">确 定</div>-->
    <!--      </div>-->
    <!--    </el-dialog>-->
  </div>
</template>
<script>
import {Icon, Poptip} from 'view-design'
import AccountTip from '@/views/pc/promotion/account/modal/Tip.vue'
import Withdraw from '@/components/promotion/Withdraw.vue'
import BalanceTip from '@/views/pc/promotion/account/modal/BalanceTip.vue'
import withdrawIndex from '@/views/pc/withdraw/index.vue'
import {accountIndex, accountInfo, changeAlipayQrcode, getAlipayQuery} from '@/api/account'
import pay from '@/javaApi/pay.js'
import QRCode from "qrcodejs2";

const payModel = new pay()
export default {
  name: 'PromotionAccount',
  components: {
    Icon,
    AccountTip,
    Withdraw,
    BalanceTip,
    Poptip,
    withdrawIndex
  },
  data: function () {
    return {
      balance: '',
      freeze_amount: '',
      rechargeAmountList: [],
      alipayRealName: '',
      alipayAccount: '',
      moneyActiveIndex: 0,
      selectMoney: '',
      alipayTrade: '',
      qrcode_status: 0,
      qrcode_url: '',
      qrcode_msg: '',
      withdrawInfo: {
        max_withdraw_amount: ''
      },
      balanceTipInfo: {
        min_balance: '',
        sms_tip_mobile: ''
      },
      recharge: false, // 判断是提现还是充值
      price: '',
      type: 0, // 默认银行卡提现
      // 提现类别
      typeList: [
        {
          text: '银行卡'
        },
        {
          text: '支付宝'
        }
      ],
      name: '', // 收款人姓名
      number: '', // 收款人账户
      addImage: require('@/assets/img/promotion/yetx_add.png'),
      active: false, // 选择添加银行卡
      activeCard: false, // 选择银行卡
      addVisible: false, // 添加银行卡弹窗
      cardType: '', // 开户行
      cardNumber: '',
      cardName: '',
      hintShow: true,
      isPayType: 0, // 支付方式1支付宝2微信3银联
      isPayTitle: '', //标题
      isPayText: '', // 提示
      isPayImg: '', // 图片
      isPayBgColor: '', // 背景色
      qrcodeImg: '', //充值二维码
      openSxyPay: '', // 是否开启了首信易开关
      payType: '', // 付款方式
      focusActive: false, // 聚焦
      loading: false
    }
  },
  created() {
    this.openSxy()
    if (this.$route.query.recharge) {
      this.recharge = this.$route.query.recharge
    }
    console.log('this.recharge', this.recharge)
    console.log(this.$route.query.recharge)
    this.accountIndex()
  },
  methods: {
    accountIndex() {
      accountIndex()
        .then(response => {
          this.balance = response.data.max_withdraw_amount
          this.freeze_amount = response.data.freeze_amount
          this.rechargeAmountList = response.data.rechargeAmountList.value
          this.alipayRealName = response.data.alipayRealName.value
          this.alipayAccount = response.data.alipayAccount.value
          this.qrcode_status = response.data.payqrcode.code
          this.qrcode_url = response.data.payqrcode.url
          this.withdrawInfo.max_withdraw_amount = response.data.max_withdraw_amount
          this.balanceTipInfo.min_balance = response.data.min_balance
          this.balanceTipInfo.sms_tip_mobile = response.data.sms_tip_mobile
          // 默认充值金额是第一个
          this.selectMoney = this.rechargeAmountList[0]
          // 默认支付宝支付
          this.selectPay(1)
          if (response.data.payqrcode.code === 0) {
            console.log(response.data.payqrcode.msg)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    refreshAccount() {
      accountInfo()
        .then(response => {
          this.$Message.success('刷新成功')
          this.balance = response.data.max_withdraw_amount
          this.freeze_amount = response.data.freeze_amount
        })
        .catch(error => {
          console.log(error)
        })
    },
    showTip: function () {
      var orderInfo = new Object()
      var type = 1
      if (this.alipayTrade === '') {
        orderInfo.title = '提示'
        orderInfo.errorDesc = '请填支付宝交易订单号'
        orderInfo.createTime = ''
        orderInfo.amount = 0
        orderInfo.tradeNo = ''
        this.$refs.AccountTip.init(4, orderInfo)
      } else {
        // getAlipayQuery({'trade_no':this.alipayTrade}).then(response => {
        //   if(response.data.code === 200){
        //     orderInfo.title = '充值成功'
        //     orderInfo.errorDesc = response.data.msg
        //     orderInfo.createTime = response.data.date
        //     orderInfo.amount = response.data.money
        //     orderInfo.tradeNo = this.alipayTrade
        //     type = 1
        //   }else{
        //     orderInfo.title = '提示'
        //     orderInfo.errorDesc = response.data.msg
        //     orderInfo.createTime = ''
        //     orderInfo.amount = 0
        //     orderInfo.tradeNo = this.alipayTrade
        //     type = 3;
        //   }
        //   this.$refs.AccountTip.init(type, orderInfo)
        // }).catch(error => {
        //   console.log(error)
        //   orderInfo.title = '提示'
        //   orderInfo.errorDesc = ''
        //   orderInfo.createTime = ''
        //   orderInfo.amount = 0
        //   orderInfo.tradeNo = this.alipayTrade
        //   this.$refs.AccountTip.init(type, orderInfo)
        // })
        let params = {
          outTradeNo: this.alipayTrade
        }
        payModel
          .getPayOrderList(params)
          .then(response => {
            console.log(response)
            if (response.data.code === 200) {
              orderInfo.title = '充值成功'
              orderInfo.errorDesc = response.data.msg
              orderInfo.createTime = response.data.data.information.completeDateTime
              console.log(orderInfo.createTime)
              orderInfo.amount = response.data.data.information.orderAmount / 100
              orderInfo.tradeNo = this.alipayTrade
              type = 1
            } else {
              orderInfo.title = '提示'
              orderInfo.errorDesc = response.data.msg
              orderInfo.createTime = ''
              orderInfo.amount = 0
              orderInfo.tradeNo = this.alipayTrade
              type = 3
            }
            this.$refs.AccountTip.init(type, orderInfo)
          })
          .catch(error => {
            console.log(error)
            orderInfo.title = '提示'
            orderInfo.errorDesc = ''
            orderInfo.createTime = ''
            orderInfo.amount = 0
            orderInfo.tradeNo = this.alipayTrade
            this.$refs.AccountTip.init(type, orderInfo)
          })
      }
    },
    withdraw: function () {
      this.recharge = false
      // this.$refs.withraw.init()
    },
    balanceTip: function () {
      this.$refs.BalanceTip.init()
    },
    chooseMoney: function (item, index) {
      this.focusActive = false
      this.loading = true
      this.moneyActiveIndex = index
      this.selectMoney = item
      // 当openSxyPay等于3是使用首信易支付
      if (this.openSxyPay == 3) {
        this.getQrcode(this.selectMoney)
      } else {
        payModel.changeAlipayQrcode({money: this.selectMoney, paymentMethod: this.payType})
          .then(response => {
            this.qrcode_status = response.data.code
            this.qrcode_url = response.data.data
            console.log('qrcode_url', this.qrcode_url)
            if (this.payType == 1 || this.payType == 2) {
              document.getElementById("qrcode").innerHTML = "";
              this.qrcode(this.qrcode_url)
            }
            if (response.data.code === 0) {
              console.log(response.data.msg)
            }
          })
          .catch(error => {
            console.log(error)
          }).finally(()=>{
            this.loading = false
        })
      }
    },
    subCustomMoney: function () {
      this.loading = true
      let reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^[0-9]\.[0-9]([0-9])?$)/
      if (!reg.test(this.selectMoney)) {
        this.$alert('请输入金额')
        this.loading = false
        return false
      }
      if (this.selectMoney.length > 7) {
        this.$message.error('金额不能超过7位数');
        this.loading = false
        return false;
      }
      // 当openSxyPay等于3是使用首信易支付
      if (this.openSxyPay == 3) {
        this.getQrcode(this.selectMoney)
      } else {
        payModel.changeAlipayQrcode({money: this.selectMoney, paymentMethod: this.payType})
          .then(response => {
            this.qrcode_status = response.data.code
            this.qrcode_url = response.data.data
            if (response.data.code === 0) {
              console.log(response.data.msg)
            }
            if (this.payType == 1 || this.payType == 2) {
              document.getElementById("qrcode").innerHTML = "";
              this.qrcode(this.qrcode_url)
            }
          })
          .catch(error => {
            console.log(error)
          }).finally(()=>{
            this.loading = false
        })
      }
      // changeAlipayQrcode({'money':this.$refs.customMoney.value}).then(response => {
      //   this.qrcode_status = response.data.code
      //   this.qrcode_url = response.data.url
      //   if(response.data.code === 0) {
      //     console.log(response.data.msg)
      //   }
      // }).catch(error => {
      //   console.log(error)
      // })
    },
    // 选择提现方式
    select(index) {
      this.type = index
    },
    // 提现全部
    selectAll() {
      this.price = this.balance
    },
    // 添加银行卡
    addCard() {
      this.active = true
      // this.hintShow = false
      this.addImage = require('@/assets/img/promotion/bank_btn_add_s.png')
      this.addVisible = true
    },
    // 选择银行卡
    selectCard() {
      this.activeCard = true
    },
    close() {
      this.addVisible = false
    },
    getName(e) {
      console.log(e)
    },
    // 选择支付方式
    selectPay(index, money,str) {
      this.loading = true
      this.isPayType = index
      let type
      if (index == 1) {
        this.isPayTitle = '支付宝'
        this.isPayText = '打开支付宝[扫一扫]'
        this.isPayImg = 'https://web.taototo.cn/seller/image/withdrawal_btn_alipay.png'
        this.isPayBgColor = '#00AAEE'
        type = 2
      }
      if (index == 2) {
        this.isPayTitle = '微信支付'
        this.isPayText = '用微信扫一扫付款'
        this.isPayImg = 'https://web.taototo.cn/seller/image/withdrawal_btn_wechat.png'
        this.isPayBgColor = '#0EC060'
        type = 1
      }
      if (index == 3) {
        this.isPayTitle = '银联支付'
        this.isPayText = '请使用云闪付或各大银行app扫码'
        this.isPayImg = 'https://yingpiao.oss-cn-shenzhen.aliyuncs.com/images/tixian_icon_bank%402x.png'
        this.isPayBgColor = '#0067B7'
        type = 0
      }
      this.payType = type
      // 当openSxyPay等于3是使用首信易支付
      if (this.openSxyPay == 3) {
        this.getQrcode(this.selectMoney)
      } else {
        payModel.changeAlipayQrcode({money:this.selectMoney, paymentMethod: this.payType})
          .then(response => {
            this.qrcode_status = response.data.code
            this.qrcode_url = response.data.data
            if (type == 1 || type == 2) {
              document.getElementById("qrcode").innerHTML = "";
              this.qrcode(this.qrcode_url)
            }
            if (response.data.code === 0) {
              console.log(response.data.msg)
            }
          })
          .catch(error => {
            console.log(error)
          }).finally(()=>{
            this.loading = false
        })
      }
      // this.getQrcode(this.selectMoney)
    },
    //生成二维码
    qrcode(url) {
      let qrcode = new QRCode(this.$refs.qrcode, {
        text: url,
        width: 120,
        height: 120,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
      })
    },
    // 获取充值二维码
    getQrcode(money) {
      let type
      if (this.isPayType == 1) {
        type = 2
      }
      if (this.isPayType == 2) {
        type = 1
      }
      if (this.isPayType == 3) {
        type = 0
      }
      let params = {
        money: money,
        paymentMethod: type
      }
      payModel.recharge(params).then(res => {
        console.log('res', res)
        if (res.data.code == 200) {
          this.qrcodeImg = 'data:image/png;base64,' + res.data.data.scanCode
        } else {
          this.$toast(res.data.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 是否打开首信易开关
    openSxy() {
      payModel.openIsSxy().then(res => {
        if (res.data.code == 200) {
          console.log(res)
          this.openSxyPay = res.data.data
          console.log('this.openSxyPay', this.openSxyPay)
        } else {
          this.$toast(res.data.message)
        }
      })
    },
    // 聚焦
    handleFocus() {
      this.focusActive = true
    },
    // 失焦
    hanDleBlur() {
      this.focusActive = false
    }
  }
}
</script>
<style scoped lang="less">
.btn {
  background: #ff8622;
  border-radius: 2px;
  color: #fff;
  cursor: pointer;
}

.tilte-text {
  font-size: 20px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.wrapper {
  width: 100%;
  @media (max-width: 1200px) {
    min-width: 1000px !important;
  }
}

.wrapper .form-group {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.4rem;
  width: 100%;
  min-width: 0;
  align-content: center;
  align-items: center;
}

.wrapper .form-group.money-form {
  margin-top: 0.2rem;
}

.wrapper .form-group:first-child {
  margin-top: 1.02rem;
}

.wrapper .form-group.alipay-code {
  align-items: flex-start;
}

.wrapper .form-group .label-wrap {
  font-size: 14px;
  color: #666666;
  width: 1.8rem;
  margin-right: 0.2rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.wrapper .form-group .label-wrap .label-icon {
  margin-left: 5px;
  margin-top: -1px;
}

.wrapper .form-group .form-item-wrap {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.wrapper .form-group .form-item-wrap.font-normal {
  font-size: 14px;
  color: #222222;
}

.wrapper .form-group .form-item-wrap .money {
  font-size: 20px;
  color: #333333;
  line-height: 27px;
  display: inline-block;
  font-weight: bolder;
}

.wrapper .form-group .form-item-wrap .refresh {
  margin-left: 0.4rem;
  font-size: 14px;
  color: #999999;
  letter-spacing: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  cursor: pointer;
}

.wrapper .form-group .form-item-wrap .refresh .refresh-text {
  font-size: 14px;
  color: #999999;
  cursor: pointer;
}

.wrapper .form-group .form-item-wrap .btn-wrapper {
  margin-left: 0.8rem;
  padding: 0.12rem 0.68rem;
  background: #ff8622;
  border-radius: 2px;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
}

.wrapper .form-group .form-item-wrap .btn-sms-tip {
  margin-left: 0.8rem;
  padding: 0.12rem 0.68rem;
  background: #0099ff;
  border-radius: 2px;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
}

.wrapper .form-group .form-item-wrap .alipay-icon-wrap {
  // width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
}

.wrapper .form-group .form-item-wrap .alipay-icon-wrap img {
  // width: 100%;
  // height: 100%;
 width: 24px;
 height: 24px;
}

.wrapper .form-group .form-item-wrap .alipay-text {
  font-size: 14px;
  color: #222222;
}

.wrapper .form-group .form-item-wrap .money-list {
  width: 100%;
}

.wrapper .form-group .form-item-wrap .money-list li {
  display: inline-block;
  margin-right: 0.4rem;
  margin-top: 0.2rem;
  vertical-align: middle;
}

.wrapper .form-group .form-item-wrap .money-list .money-list-item {
  padding: 0.16rem 0.6rem;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  cursor: pointer;
  font-size: 14px;
}

@media screen and (max-width: 1450px) {
  .wrapper .form-group .form-item-wrap .money-list li {
    margin-bottom: 0.2rem;
  }
}

.wrapper .form-group .form-item-wrap .money-list .money-list-item.active {
  border: 1px solid #ff8622;
  border-radius: 2px;
  color: #ff8622;
}
.money-wrapper_active{
  border: 1px solid #ff8622!important;
  border-radius: 2px;
}
.wrapper .form-group .form-item-wrap .money-list .money-list-item.confirm-btn {
  background: #ff8622;
  color: #fff;
  border-radius: 2px;
}

.wrapper .form-group .form-item-wrap .money-list .other-money .money-tip {
  width: 1.12rem;
  display: inline-block;
  margin-right: 10px;
  font-size: 14px;
  color: #666666;
  vertical-align: middle;
}

.wrapper .form-group .form-item-wrap .money-list .other-money .money-wrapper {
  display: inline-block;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  vertical-align: middle;
}

.wrapper .form-group .form-item-wrap .money-list .other-money .money-wrapper input {
  width: 2.68rem;
  padding: 0.16rem 0.6rem;
}

.wrapper .form-group .form-item-wrap .alipay-code-wrap {
  width: 100%;
  display: flex;
  align-items: flex-end;
}

.wrapper .form-group .form-item-wrap .alipay-code-desc {
  flex: 1;
  min-width: 0;
  margin-left: 0.6rem;
  background: #fafafa;
  padding: 0.4rem;
}

.wrapper .form-group .form-item-wrap .recharge-tip {
  font-size: 14px;
  color: #ff4f76;
  width: 100%;
}

.wrapper .form-group .form-item-wrap .order-input {
  margin-top: 0.56rem;
  font-size: 14px;
  color: #666666;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.wrapper .form-group .form-item-wrap .icon-div {
  margin-left: 5px;
  margin-right: 15px;
}

.wrapper .form-group .form-item-wrap .order-input-content {
  border: 1px solid #eeeeee;
  border-radius: 2px;
  margin-right: 0.4rem;
}

.wrapper .form-group .form-item-wrap .order-input-content input {
  padding: 8px 10px;
  width: 5.74rem;
  color: #333;
}

.wrapper .form-group .form-item-wrap .order-input-content input::placeholder {
  font-size: 14px;
  color: #c1c1c1;
}

.wrapper .form-group .form-item-wrap .order-input-content input ::-webkit-input-placeholder {
  font-size: 14px;
  color: #c1c1c1;
}

/* Mozilla Firefox 4 to 18 */
.wrapper .form-group .form-item-wrap .order-input-content input:-moz-placeholder {
  font-size: 14px;
  color: #c1c1c1;
}

/* Mozilla Firefox 19+ */
.wrapper .form-group .form-item-wrap .order-input-content input::-moz-placeholder {
  font-size: 14px;
  color: #c1c1c1;
}

/* Internet Explorer 10+ */
.wrapper .form-group .form-item-wrap .order-input-content input:-ms-input-placeholder {
  font-size: 14px;
  color: #c1c1c1;
}

.order-btn .btn {
  padding: 7px 30px;
  font-size: 15px;
  cursor: pointer;
  display: inline-block;
}

@media screen and (max-width: 1100px) {
  .order-btn .btn {
    margin-top: 0.2rem;
  }
}

.wrapper .form-group .order-tip-div {
  width: 100%;
  font-size: 14px;
  color: #999999;
  margin-top: 10px;
}

/* .alipay_box_img {
  width: 220px;
  height: 300px;
  text-align: center;
} */
.alipay_box_img .pay-qrcode-img {
  position: relative;
}

.alipay_box_img .pay-qrcode-img .bg-img {
  width: 240px;
}

.alipay_box_img .pay-qrcode-img .qrcode-img {
  text-align: center;
  background: #f5f5fa;
  width: 120px;
  position: absolute;
  top: 148px;
  left: 50%;
  transform: translateX(-50%);
  -ms-transform: translateX(-50%); /* IE 9 */
  -moz-transform: translateX(-50%); /* Firefox */
  -webkit-transform: translateX(-50%); /* Safari 和 Chrome */
  -o-transform: translateX(-50%); /* Opera */
}

.alipay_box_img .pay-qrcode-img .qrcode-img img {
  width: 100%;
}

.alipay_qr_header {
  height: 60px;
  line-height: 60px;
  box-shadow: 0px 0px 4px 0px #eeeeee;
}

.alipay_qr_content {
  width: 222px;
  height: 240px;
  background: #00aaee 100%;
  padding-top: 40px;
  margin-left: -1px;
}

.alipay_qr_content .alipay_qrcode {
  width: 130px;
  height: 130px;
  background: #fff;
  margin: 0 auto;
  display: inline-block;
  padding: 5px;
}

.alipay_qr_content .alipay_qrcode img {
  width: 100%;
}

.alipay_qr_text {
  color: #fff;
  margin-top: 15px;
}

/*提现样式*/
.input-price {
  width: 260px;
  height: 40px;
  background: #ffffff;
}

.price-text {
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #999999;
  line-height: 20px;
  margin-left: 10px;
}

.price-all {
  color: rgba(61, 158, 252, 1);
  cursor: pointer;
}

.price-div {
  width: 120px;
  height: 40px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #eeeeee;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #666666;
  line-height: 40px;
  text-align: center;
  margin-right: 20px;
  cursor: pointer;
}

.price-div-active {
  border: 1px solid #ff8622;
  color: #ff8622;
}

.price-hint {
  margin-left: 2rem;
  margin-top: 20px;
}

.price-button {
  width: 90px;
  height: 36px;
  background: #ff8622;
  border-radius: 2px;
  cursor: pointer;
  text-align: center;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #ffffff;
  line-height: 36px;
  margin-left: 2rem;
  margin-top: 30px;
}

.hint-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  margin-bottom: 10px;
}

.hint-text {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff4f76;
  line-height: 17px;
}

.price-number {
  display: flex;
  align-items: center;
  margin-left: 1.8rem;
  margin-top: 6px;
}

.price-span {
  color: rgba(51, 51, 51, 1);
}

.price-span2 {
  color: rgba(255, 134, 34, 1);
}

.price-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-left: 2rem;
  margin-top: 32px;
}

.list-item {
  width: 260px;
  height: 80px;
  background: #ffffff linear-gradient(253deg, #3a94db 0%, #3360d6 100%);
  border-radius: 2px;
  cursor: pointer;
}

.list-item-active {
  width: 260px;
  height: 80px;
  background: linear-gradient(253deg, #3a94db 0%, #3360d6 100%);
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  border: 1px solid #ff8622;
  transition: margin-top 1s;
  margin-top: -20px;
  cursor: pointer;
}

.list-add {
  width: 260px;
  height: 80px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #eeeeee;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 25px;
  cursor: pointer;
}

.list-add-active {
  border: 1px solid #ff8622;
}

.list-add-text-active {
  color: #ff8622 !important;
}

.list-add-icon {
  width: 24px;
  height: 24px;
}

.list-add-text {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  margin-left: 4px;
}
</style>
<style lang="less" scoped>
.card-message {
  //padding: 20px;
  .message-item {
    display: flex;
    align-items: center;
    margin-bottom: 22px;

    .item-text {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 20px;
      width: 60px;
      text-align: right;
      margin-right: 16px;
    }

    .item-input {
      width: 314px;
      height: 36px;
      border-radius: 2px;
      border: 1px solid #c1c1c1;

      input {
        width: 95%;
        height: 100%;
        margin-left: 10px;
      }
    }

    .item-select {
      width: 314px;
      height: 36px;
    }
  }

  .message-hint {
    font-size: 12px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #c1c1c1;
    line-height: 17px;
    margin-left: 85px;
    margin-top: -15px;
  }

  .card-button {
    display: flex;
    align-items: center;
    justify-content: center;

    .card-button-confirm {
      width: 100px;
      height: 36px;
      background: #ff8622;
      border-radius: 2px;
      text-align: center;
      font-size: 16px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #ffffff;
      line-height: 36px;
      cursor: pointer;
    }

    .card-button-cancel {
      font-size: 16px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      line-height: 36px;
      text-align: center;
      width: 100px;
      height: 36px;
      background: #eeeeee;
      border-radius: 2px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
}

.card-hint-text {
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #666666;
  line-height: 22px;
}

.card-hint-confirm {
  width: 100px;
  height: 36px;
  background: #ff8622;
  border-radius: 2px;
  text-align: center;
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #ffffff;
  line-height: 36px;
  cursor: pointer;
  margin: auto;
  margin-top: 30px;
}

.selected {
  color: #ff8622;
  background: #fcfaf8;
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: #ff8622 !important;
}

/deep/ .el-select .el-input__inner:focus {
  border-color: #ff8622 !important;
}

.item-input:hover {
  border: 1px solid #ff8622 !important;
}

input::-webkit-input-placeholder {
  /* WebKit browsers */
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #c1c1c1;
  line-height: 20px;
}

input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #c1c1c1;
  line-height: 20px;
}

input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #c1c1c1;
  line-height: 20px;
}

input::-ms-input-placeholder {
  /* Internet Explorer 10+ */
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #c1c1c1;
  line-height: 20px;
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #eeeeee;
}
</style>
<style lang="less" scoped>
.pay {
  display: flex;
  align-items: center;

  .pay-item {
    width: 160px;
    height: 48px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #e8e8e8;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    cursor: pointer;

    img {
      width: 28px;
      height: 28px;
    }

    .pay-item-text {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3f3a39;
      line-height: 25px;
      margin-left: 5px;
    }
  }

  .pay-item-active {
    border-radius: 2px;
    border: 1px solid #ff8622;
  }
}

.pay-qrcode {
  width: 220px;
  height: 300px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);
  margin-top: 30px;

  .qrcode-top {
    height: 60px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 28px;
      height: 28px;
    }

    .qrcode-top-text {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 25px;
      margin-left: 8px;
    }
  }

  .qrcode-center {
    width: 220px;
    height: 240px;
    background: #0ec060;
    padding-top: 40px;

    .qrcode-center-img {
      width: 120px;
      height: 120px;
      background: #fafafa;
      margin: auto;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .qrcode-center-text {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      margin-top: 20px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/account/Index.vue